import { Link } from 'react-router-dom'
import { FiInstagram } from 'react-icons/fi'
import { SiTiktok } from 'react-icons/si'
import { APP_CONFIG } from '../../utils/constants'

const Footer = () => {
  const currentYear = new Date().getFullYear()
    
  const footerSections = [
    {
      title: 'Acerca de nosotros',
      links: [
        { title: 'Sobre nosotros', to: '/sobre-nosotros' },
        { title: 'Términos y condiciones', to: '/terminos-y-condiciones' },
        { title: 'Preguntas frecuentes', to: '/preguntas-frecuentes' },
        { title: 'Aviso de privacidad', to: '/aviso-de-privacidad' },
        { title: 'Eliminación de cuenta', to: '/eliminar-cuenta' }
      ]
    }
  ]
    
  const socialLinks = [
    {
      name: 'Instagram',
      href: APP_CONFIG.SOCIAL_LINKS.INSTAGRAM,
      icon: FiInstagram
    },
    {
      name: 'TikTok',
      href: APP_CONFIG.SOCIAL_LINKS.TIKTOK,
      icon: SiTiktok
    }
  ]
    
  return (
    <footer className="bg-primary-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
                    
          {/* Footer Sections */}
          {footerSections.map((section, index) => (
            <div key={index} className="space-y-4 text-center">
              <h3 className="text-sm font-body text-black">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.to}
                      className="font-body font-light text-sm text-black hover:text-primary-black/50 transition-colors duration-300"
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
                    
          {/* Social Links */}
          <div className="space-y-4 text-center pt-4">
            <div className="flex space-x-4 justify-center">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primary-gray hover:text-primary-text hover:shadow-lg transform hover:scale-110 transition-all duration-300"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
                
        {/* Bottom Footer */}
        <div className="py-4">
          <div className="text-center">
            <p className="text-sm text-primary-black font-title font-light">
              © {currentYear} {APP_CONFIG.NAME}. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer